import axios from 'axios'

const CrmService = {
    async getContactInfoByPhone(phone) {
        const data = {
            'p': phone
        }
        let resp = await axios.get('/api/v1/get-contact-info', {params: data})
        return resp.data ? resp.data : false
    }
}

export default CrmService